module.exports = __webpack_public_path__ + "img/logo_white_packhai_fulfillment.e1051293.png";